class DynamicProductCardSearch extends HTMLElement {
  constructor() {
    super();
  }

  async updateCard() {
    const handle = this.getAttribute('handle');
    if (!handle) return;

    const url = `/products/${handle}?section_id=product-card-search`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to load product card for ${handle}`);
      }

      const html = await response.text();

      // Parse HTML and isolate the inner content of the section wrapper
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const sectionWrapper = doc.querySelector('.search_product_card_wrap');

      if (sectionWrapper) {
        this.innerHTML = ''; // Clear existing content
        this.appendChild(sectionWrapper);
      } else {
        // Fallback: insert entire HTML if wrapper not found
        this.replaceWith(document.createRange().createContextualFragment(html));
      }
    } catch (error) {
      console.error(error);
      this.replaceWith(document.createTextNode('Failed to load product card'));
    }
  }

  async connectedCallback() {
    await this.updateCard();
  }

  static get observedAttributes() {
    return ['handle'];
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    await this.updateCard();
  }
}

customElements.define('dynamic-product-card-search', DynamicProductCardSearch);
  